import type { FC } from "react";

import { RoundButton } from "@ui/components/RoundButton";
import { useTranslations } from "@ui/providers/useTranslations";
import classNames from "classnames";

import { UiCrossIcon } from "@jti/brand-icons/ui-cross";

import styles from "./DialogCloseButton.module.scss";

type DialogCloseButtonProps = {
  onClick?: () => void;
  buttonClassName?: string;
  containerClassName?: string;
};

export const DialogCloseButton: FC<DialogCloseButtonProps> = ({ onClick, buttonClassName, containerClassName }) => {
  const { __ } = useTranslations();
  return (
    <div className={classNames(styles.closeButtonWrapper, containerClassName)}>
      <RoundButton
        icon={UiCrossIcon}
        onClick={onClick}
        className={buttonClassName}
        data-testid="modal-close-icon-button"
        aria-label={__("common.close")}
      />
    </div>
  );
};
